<template>
  <div :class="[classes.marketCard, 'market-card']">
    <slot />
  </div>
</template>

<script lang="ts">
import { computed } from "vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { defineComponent } from "@vue/composition-api";

const { useStyles } = createUseStyles(
  {
    marketCard: {
      minWidth: "212px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      border: props => `1px solid ${props.marketBorderColor}`,
      borderRadius: "4px",
      flex: "1 1 212px",
      boxSizing: "border-box"
    }
  },
  { marketBorderColor: "#dcddf" }
);

export default defineComponent({
  name: "StyledMarketCard",
  setup() {
    const { adTemplate, getColorStyle } = injectBrand();

    const { classesRef } = useStyles(
      computed(() => ({
        marketBorderColor: getColorStyle(adTemplate.value.marketBorderColor)
      }))
    );

    return {
      classes: classesRef
    };
  }
});
</script>
